import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-013d56a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "customer" }
const _hoisted_2 = { class: "contents" }
const _hoisted_3 = { class: "heaer-address" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/" }, "首页", -1))
const _hoisted_5 = { class: "customer-contents" }
const _hoisted_6 = { class: "customer-left" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "title-c" }, "客户服务")
], -1))
const _hoisted_8 = {
  key: 0,
  class: "f-title"
}
const _hoisted_9 = { class: "f-title-c" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "icon iconfont icon-xiala"
}
const _hoisted_12 = {
  key: 1,
  class: "icon iconfont icon-youjiantou"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "s-title" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-yuandian" }, null, -1))
const _hoisted_17 = { class: "customer-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HomeHead = _resolveComponent("HomeHead")!
  const _component_CurrentAddress = _resolveComponent("CurrentAddress")!
  const _component_html_footer = _resolveComponent("html-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HomeHead),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CurrentAddress, null, {
          address: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" > 客户服务")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nowClassList.data, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (item.type && item.type == 'master')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(item.name), 1)
                  ]))
                : (item.list && item.list.length > 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "s-title",
                      onClick: ($event: any) => (_ctx.clickOpenClass(index))
                    }, [
                      _createElementVNode("p", {
                        class: _normalizeClass(["ul-title", { active: item.isChecked }])
                      }, [
                        _createElementVNode("span", null, _toDisplayString(item.name), 1),
                        (item.open)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_11))
                          : (_openBlock(), _createElementBlock("i", _hoisted_12))
                      ], 2)
                    ], 8, _hoisted_10))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: "s-title",
                      onClick: ($event: any) => (_ctx.clickClass(index, 0))
                    }, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("p", {
                          class: _normalizeClass(["s-title-c", { active: item.isChecked }])
                        }, _toDisplayString(item.name), 3)
                      ])
                    ], 8, _hoisted_13)),
              (item.list && item.list.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(item.list, (itemson, indexson) => {
                    return _withDirectives((_openBlock(), _createElementBlock("div", {
                      class: "s-title",
                      onClick: ($event: any) => (_ctx.clickClass(index, indexson))
                    }, [
                      _createElementVNode("p", {
                        class: _normalizeClass(["li-title", { active: itemson.isChecked }])
                      }, [
                        _hoisted_16,
                        _createTextVNode(_toDisplayString(itemson.name), 1)
                      ], 2)
                    ], 8, _hoisted_15)), [
                      [_vShow, item.open]
                    ])
                  }), 256))
                : _createCommentVNode("", true)
            ], 64))
          }), 256))
        ]),
        _createElementVNode("div", _hoisted_17, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.comName)))
        ])
      ])
    ]),
    _createVNode(_component_html_footer)
  ]))
}